import { render, staticRenderFns } from "./RateVersionManager.vue?vue&type=template&id=4aa267aa&scoped=true"
import script from "./RateVersionManager.vue?vue&type=script&lang=js"
export * from "./RateVersionManager.vue?vue&type=script&lang=js"
import style0 from "./RateVersionManager.vue?vue&type=style&index=0&id=4aa267aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa267aa",
  null
  
)

export default component.exports